import { render, staticRenderFns } from "./ManageSuppliers.vue?vue&type=template&id=8ea955b0&scoped=true&"
import script from "./ManageSuppliers.vue?vue&type=script&lang=js&"
export * from "./ManageSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./ManageSuppliers.vue?vue&type=style&index=0&id=8ea955b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea955b0",
  null
  
)

export default component.exports